
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { AddRentalForm } from './AddRentalForm';

interface AddRentalDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
  loading: boolean;
  couriers: any[];
  bikes: any[]; // Добавляем свойство bikes в интерфейс
}

export const AddRentalDialog: React.FC<AddRentalDialogProps> = ({
  open,
  onOpenChange,
  onSubmit,
  loading,
  couriers,
  bikes // Добавляем параметр bikes в деструктурирование
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Добавить аренду</DialogTitle>
        </DialogHeader>
        <AddRentalForm 
          onSubmit={onSubmit} 
          loading={loading}
          couriers={couriers}
          bikes={bikes} // Передаем bikes в AddRentalForm
        />
      </DialogContent>
    </Dialog>
  );
};
